import { useState, useEffect, useRef } from "react";


/**
 * @description: This custom hook receives a list of sources to be loaded and returns
 * an object with three state values: hasLoaded:boolean, hasError:boolean and hastStatedInitialFetch:boolean.
 *
 * @param sources: string[] | undefined
 */
export const useLoadImages = (sources?: string[] | undefined) => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [hasStartedInitialFetch, setHasStartedInitialFetch] = useState(false);
  const loadedImageCount = useRef(0);
  const [cachedImagesList, setCachedImagesList] = useState<string[]>([]);

  useEffect(() => {
    if (sources && sources.length > 0) {
      const handleError = () => {
        setHasError(true);
      };
      const handleLoad = (event: any) => {
        loadedImageCount.current += 1;
        if (loadedImageCount.current === sources?.length) {
          const path = event.currentTarget.attributes.src.nodeValue;
          setHasLoaded(true);
          let newList = cachedImagesList;
          if (newList.includes(path) === false) {
            newList.push(path);
          }
          setCachedImagesList(newList);
        }
      };

      const imageList: HTMLImageElement[] = [];
      let isLoadedFlag: Boolean = true;
      loadedImageCount.current = 0;
      sources.forEach((src) => {
        if (!cachedImagesList.includes(src)) {
          isLoadedFlag = false;
          setHasStartedInitialFetch(true);
          setHasLoaded(false);
          setHasError(false);

          const image = new Image();
          image.src = src;

          image.onerror = handleError;
          image.onload = handleLoad;
          imageList.push(image);
        }
      });

      if (isLoadedFlag) {
        setHasLoaded(true);
      }

      return () => {
        imageList.forEach((image) => {
          image.removeEventListener("error", handleError);
          image.removeEventListener("load", handleLoad);
        })
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sources]);

  return { hasLoaded, hasError, hasStartedInitialFetch };
};